import { useQuery } from '@apollo/react-hooks';

import featuresQuery from './features.gql';

const DEFAULT_FEATURE_FLAGS = {};
let featureFlags = DEFAULT_FEATURE_FLAGS;

const useFeatureFlags = (userId, options = {}) => {
  const { data, loading, error } = useQuery(featuresQuery, {
    variables: { id: userId },
    ...options,
  });

  if (!loading) featureFlags = data?.host?.features || DEFAULT_FEATURE_FLAGS;

  return { featureFlags, isFeatureLoading: loading, isFeatureError: error };
};

export default useFeatureFlags;
